import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ContactModal from "../ContactModal";

function CommentMarche() {
    return (
            <>
                <h2 className="libre-title mb-5">Comment ça marche ? Bourso</h2>
                <div className="d-flex align-items-center">
                    <img className='img-icon-modal' src="/images/resource/check.png" alt="check"/>
                    <div className="modal-content-hotline">
                        <h1>Réservez</h1>
                        <span>Choisissez un créneau de 15 minutes</span>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <img className='img-icon-modal' src="/images/resource/avatar.png" alt="avatar"/>
                    <div className="modal-content-hotline">
                        <h1>Échangez</h1>
                        <span>Avec nos experts Talents Handicap</span>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <img className='img-icon-modal' src="/images/resource/cadenas.png" alt="cadenas"/>
                    <div className="modal-content-hotline">
                        <h1>Confidentialité garantie</h1>
                        <span>Vos échanges restent privés</span>
                    </div>
                </div>

                <div className="text-left pb-1 pt-4">
                    <div className="text">
                        <span>Notre promesse :</span>
                        <ul className="list-style-three">
                            <li>Un accompagnement professionnel, bienveillant, et sécurisé pour toutes
                                vos
                                questions sur le handicap au travail.
                            </li>
                            <li>Vos coordonnées ne seront jamais communiquées à votre employeur.</li>
                        </ul>
                    </div>
                    {/*                            <motion.a
                                                href=""
                                                className="theme-btn btn-style-one small mt-3"
                                                initial={{opacity: 1, y: 20}}
                                                animate={{opacity: 1, y: 20}}
                                                transition={{delay: 1.0, duration: 1.5}}
                                            >
                                                Réserver votre créneau
                                            </motion.a>*/}

                    {/*<motion.button
                                                className="theme-btn btn-style-one small mt-3"
                                                initial={{opacity: 1, y: 20}}
                                                animate={{opacity: 1, y: 20}}
                                                transition={{delay: 1.0, duration: 1.5}}
                                                data-cal-namespace="ligne-inclusion"
                                                data-cal-link="team/talents-handicap/ligne-inclusion"
                                                data-cal-config='{"layout":"month_view"}'
                                            >Réserver votre créneau
                                            </motion.button>*/}

                </div>
                <div className="text-center pb-2">
                    <ContactModal textButton="Réserver un créneau" showText={false} small="small"
                                  linkPageContact={false} iframe={true} couleur={false}/>
                </div>
            </>
    );
}

export default CommentMarche;
